import type { Release } from '../releases.ts';

export default {
  version: '0.93.1',
  date: '2026-10-08',
  title: 'Graphics stack the same in the sequence viewer as in exports',
  summary: [
    'Fixed: the sequence viewer stacks mixed graphics in track order, as the export does',
    'Fixed: graphics are placed on the picture, not against the top of the viewer',
    'Fixed: the bin’s Graphics tab keeps its cards usable with many graphics',
  ],
  features: [],
  fixes: [
    'Sequence viewer: a sequence that mixes HTML templates and OGraf graphics now stacks them strictly in the order of the graphics track, as the export does: a later graphic is drawn over an earlier one whatever its kind. Before, the viewer drew every OGraf graphic over every HTML template, so a mixed sequence could look different from its export',
    'Sequence viewer: graphics are placed on the picture itself. When the viewer is taller or wider than the sequence’s picture, they were placed against the top of the viewer instead and could sit higher than in the export',
    'Sequence editor: with many graphics in the library, the bin’s Graphics tab squeezed every card to a thin line and its buttons could not be clicked; the cards keep their size and the list scrolls',
  ],
} satisfies Release;
